import { config } from "@/config";
export const AlmacenService = {
    // --- Almacenes ---
    async getAllAlmacenes(search = "", tipoAlmacenId, page = 1, pageSize = 10) {
        const url = new URL(`${config.API_URL}/api/Almacen`);
        if (search)
            url.searchParams.append("search", search);
        if (tipoAlmacenId)
            url.searchParams.append("tipoAlmacenId", tipoAlmacenId.toString());
        url.searchParams.append("page", page.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        const response = await fetch(url.toString());
        if (!response.ok)
            throw new Error("Error al obtener almacenes");
        const result = await response.json();
        return result.datos || { items: [], totalCount: 0 };
    },
    async getAllAlmacenesSimple() {
        const response = await fetch(`${config.API_URL}/api/Almacen/all-simple`);
        if (!response.ok)
            throw new Error("Error al obtener lista de almacenes");
        const result = await response.json();
        return result.datos || [];
    },
    async getAlmacenById(id) {
        const response = await fetch(`${config.API_URL}/api/Almacen/${id}`);
        if (!response.ok)
            throw new Error("Almacén no encontrado");
        const result = await response.json();
        return result.datos;
    },
    async createAlmacen(formData) {
        const response = await fetch(`${config.API_URL}/api/Almacen`, {
            method: "POST",
            body: formData, // [FromForm] handle
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.mensaje || "Error al crear almacén");
        }
        const result = await response.json();
        return result.datos;
    },
    async updateAlmacen(id, formData) {
        const response = await fetch(`${config.API_URL}/api/Almacen/${id}`, {
            method: "PUT",
            body: formData,
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.mensaje || "Error al actualizar almacén");
        }
        const result = await response.json();
        return result.datos;
    },
    async toggleActivo(id) {
        const response = await fetch(`${config.API_URL}/api/Almacen/${id}/toggle-activo`, {
            method: "PATCH",
        });
        if (!response.ok)
            throw new Error("Error al cambiar estado");
    },
    async deleteAlmacen(id) {
        const response = await fetch(`${config.API_URL}/api/Almacen/${id}`, {
            method: "DELETE",
        });
        if (!response.ok)
            throw new Error("Error al eliminar almacén");
    },
    // --- Tipos de Almacén ---
    async getAllTipos() {
        const response = await fetch(`${config.API_URL}/api/Almacen/tipos`);
        if (!response.ok)
            throw new Error("Error al obtener tipos de almacén");
        const result = await response.json();
        return result.datos || [];
    },
    // --- Traslados ---
    async getAllTraslados(search = "", origenId, destinoId, estado, page = 1, pageSize = 10) {
        const url = new URL(`${config.API_URL}/api/Almacen/traslados`);
        if (search)
            url.searchParams.append("search", search);
        if (origenId)
            url.searchParams.append("origenId", origenId.toString());
        if (destinoId)
            url.searchParams.append("destinoId", destinoId.toString());
        if (estado)
            url.searchParams.append("estado", estado);
        url.searchParams.append("page", page.toString());
        url.searchParams.append("pageSize", pageSize.toString());
        const response = await fetch(url.toString());
        if (!response.ok)
            throw new Error("Error al obtener traslados");
        const result = await response.json();
        return result.datos || { items: [], totalCount: 0 };
    },
    async createTraslado(traslado) {
        const response = await fetch(`${config.API_URL}/api/Almacen/traslados`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(traslado),
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.mensaje || "Error al crear traslado");
        }
        const result = await response.json();
        return result.datos;
    },
    async updateTrasladoEstado(id, estadoDto) {
        const response = await fetch(`${config.API_URL}/api/Almacen/traslados/${id}/estado`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(estadoDto),
        });
        if (!response.ok)
            throw new Error("Error al actualizar estado de traslado");
        const result = await response.json();
        return result.datos;
    },
    async deleteTraslado(id) {
        const response = await fetch(`${config.API_URL}/api/Almacen/traslados/${id}`, {
            method: "DELETE",
        });
        if (!response.ok)
            throw new Error("Error al eliminar traslado");
    },
    async getTrasladoById(id) {
        const response = await fetch(`${config.API_URL}/api/Almacen/traslados/${id}`);
        if (!response.ok)
            throw new Error("Traslado no encontrado");
        const result = await response.json();
        return result.datos;
    },
    // --- Inventario ---
    async getInventario(almacenId) {
        const response = await fetch(`${config.API_URL}/api/Almacen/${almacenId}/inventario`);
        if (!response.ok)
            throw new Error("Error al obtener el inventario");
        const result = await response.json();
        return result.datos || [];
    }
};
